import { useId } from 'react';

import Button from 'components/ui/button';
import { ModalFrame } from 'components/ui/modal-frame';
import { sanitizeHtml } from 'utils/sanitizeHtml';

import { RecognitionAlertContent } from '../recognition';

interface RecognitionAlertProps {
  alert: RecognitionAlertContent;
  onClose: () => void;
}

const ALERT_BODY_CLASSES = 'flex flex-col items-center gap-5 px-5 py-6 text-center lg:px-7';
const ALERT_TEXT_CLASSES = 'm-0 text-sm leading-[1.6] text-content [text-wrap:pretty]';

/** Aviso que interrompe o reconhecimento: recusa do colega, limite, grupo restrito, mensagem repetida (REC-57). */
export function RecognitionAlert({ alert, onClose }: RecognitionAlertProps) {
  const descriptionId = useId();

  return (
    <ModalFrame
      isOpen
      size="sm"
      role="alertdialog"
      title={alert.isNotice ? 'Olá!' : 'Ops!'}
      descriptionId={descriptionId}
      onClose={onClose}
      closeLabel="Fechar aviso"
    >
      <div className={ALERT_BODY_CLASSES}>
        {/* O texto formatado vem do cadastro do Studio, então passa pelo sanitizador antes de virar HTML. */}
        {alert.html ? (
          <div id={descriptionId} className={ALERT_TEXT_CLASSES} dangerouslySetInnerHTML={{ __html: sanitizeHtml(alert.html) }} />
        ) : (
          <p id={descriptionId} className={ALERT_TEXT_CLASSES}>
            {alert.text}
          </p>
        )}

        <Button variant="solido-destaque" onClick={onClose}>
          Entendi
        </Button>
      </div>
    </ModalFrame>
  );
}

interface RelationshipConfirmProps {
  /** Segue com o colega escolhido. */
  onConfirm: () => void;
  /** Desiste do colega: a escolha é desfeita. */
  onDismiss: () => void;
}

/** O colega escolhido tem relacionamento cadastrado com quem envia: pede confirmação (REC-20). */
export function RelationshipConfirm({ onConfirm, onDismiss }: RelationshipConfirmProps) {
  const descriptionId = useId();

  return (
    <ModalFrame
      isOpen
      size="sm"
      role="alertdialog"
      title="Ops!"
      descriptionId={descriptionId}
      onClose={onDismiss}
      closeLabel="Fechar e escolher outro colega"
    >
      <div className={ALERT_BODY_CLASSES}>
        <p id={descriptionId} className={ALERT_TEXT_CLASSES}>
          Essa pessoa possui relacionamento cadastrado com você. Deseja mesmo prosseguir?
        </p>

        <Button variant="solido-destaque" onClick={onConfirm}>
          Confirmar
        </Button>
      </div>
    </ModalFrame>
  );
}
